import { CheckCircleFilled } from '@ant-design/icons';

import BaseTag from './BaseTag';

import type { FC } from 'react';

interface Props {
  small?: boolean;
}

const CompletedTag: FC<Props> = ({ small }) => {
  return (
    <BaseTag
      text="Completed"
      title="This patient completed Partials and Follow-up. Due date updated to next month."
      color="green"
      dataCy="completed-tag"
      small={small}
      icon={<CheckCircleFilled />}
    />
  );
};

export default CompletedTag;
